/* ========================================================================
   On document ready do stuff
 ========================================================================== */

util.onDocumentReady(function () {
  const body = document.getElementById('body');

  // Set frontend version
  util.frontEndVersion = body.dataset.version;

  // Set debug mode
  util.debugMode = body.dataset.debugMode === 'true';

  // Set culture
  util.uiCulture = body.dataset.culture;

  // Set language
  util.uiLanguage = util.uiCulture ? util.uiCulture.split('-')[0] : null;

  // Set homepage Id
  util.homePageId = body.dataset.homepageId;

  // Set path
  util.path = body.dataset.path;

  if (util.debugMode) {
    console.info(util.uiCulture, util.uiLanguage, util.homePageId, util.path);
    if (!util.uiCulture) console.error('Culture is not set');
    if (!util.uiLanguage) console.error('Language is not set');
    if (!util.homePageId) console.error('HomePageId is not set');
    if (!util.path) console.error('Path is not set');
  }

  // Enable transitions
  document.documentElement.removeAttribute('data-loading');

  // Enable SVG in IE11
  // svg4everybody();

  app.general.initViewportDimensions();
  // app.general.initAnchorLinks();
  app.navigation.init();
  // app.navigation.initSearchBox();
  app.general.initEmailLinks();
  // app.general.initLax();
  app.cookiePopup.init();
  app.dataLayer.init();

  const min = util.debugMode === false ? '.min' : '';

  if (document.querySelectorAll('[data-toast-message]').length > 0) {
    // show toast messages (with delay)
    const toastMessages = document.querySelectorAll('[data-toast-message]');
    toastMessages.forEach((message, index) => {
      window.setTimeout(() => {
        Toast(message.innerHTML, message.dataset.toastType.toLowerCase(), message.dataset.toastTimeout ?? 7500);
      }, index * 1000);
    });
  }

  if (document.querySelectorAll('[data-accordion-list]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules/accordion' + min + '.js'), () => {
      app.accordion.init();
    });
  }

  if (document.querySelectorAll('[data-carousel]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/plugins/embla/embla-bundle' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules/carousel' + min + '.js'),
      () => {
        app.carousel.init();
      }
    );
  }

  if (document.querySelectorAll('[data-video]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules/videos' + min + '.js'), () => {
      app.videos.init();
    });
  }

  if (document.querySelectorAll('[data-iframe-widget]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules/iframe-widgets' + min + '.js'), () => {
      app.widgets.init();
    });
  }

  if (document.querySelectorAll('[data-video-lightbox]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/plugins/video-lightbox' + min + '.js'), () => {
      const videos = document.querySelectorAll('[data-video-lightbox]');
      const lightbox = VideoLightbox(videos);

      // window.addEventListener(
      //   'CookiebotOnAccept',
      //   (event) => {
      //     if (lightbox.hasMarketingConsent()) {
      //       lightbox.removeConsentWarning();
      //     }
      //   },
      //   false
      // );
    });
  }

  if (document.querySelector('.searchResults')) {
    if (document.location.href.indexOf('?') > -1) {
      setTimeout(() => {
        document.querySelector('[data-results-anchor]').scrollIntoView({
          behavior: 'smooth',
        });
      }, 500);
    }
  }

  // ljs.load(util.getVersionedUrl('/scripts/dist/forms/newsletter' + min + '.js'), () => {
  //   // Load aspnet-validation if not loaded yet
  //   // Use a delay to make sure it doesn't conflict with Umbraco Forms' version of aspnet-validation
  //   window.setTimeout(() => {
  //     if (typeof window.aspnetValidation !== 'object') {
  //       ljs.load(
  //         '/scripts/dist/plugins/aspnet-validation.min.js',
  //         util.getVersionedUrl('/scripts/dist/forms/validation.min.js'),
  //         () => {}
  //       );
  //     }
  //   }, 2000);
  // });

  if (document.querySelectorAll('[data-generic-form]').length > 0) {
    window.setTimeout(() => {
      if (typeof window.aspnetValidation !== 'object') {
        ljs.load(
          util.getVersionedUrl('/scripts/dist/plugins/aspnet-validation' + min + '.js'),
          util.getVersionedUrl('/scripts/dist/forms/validation' + min + '.js'),
          util.getVersionedUrl('/scripts/dist/forms/generic' + min + '.js'),
          () => {
            app.genericForm.init();
          }
        );
      } else {
        ljs.load(util.getVersionedUrl('/scripts/dist/forms/generic' + min + '.js'), () => {
          app.genericForm.init();
        });
      }
    }, 1000);
  }

  if (document.querySelectorAll('[data-course-expense-report-form]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/plugins/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms/validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/plugins/upload-field' + min + '.js'), // uploadField depends on dialog and toast
      util.getVersionedUrl('/scripts/dist/forms/course-expense-report' + min + '.js'),
      () => {
        app.courseExpenseReportForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-meeting-expense-report-form]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/plugins/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms/validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/plugins/upload-field' + min + '.js'), // uploadField depends on dialog and toast
      util.getVersionedUrl('/scripts/dist/forms/meeting-expense-report' + min + '.js'),
      () => {
        app.meetingExpenseReportForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-image-lightbox]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/plugins/lightbox' + min + '.js'), () => {
      const buttons = document.querySelectorAll('[data-image-lightbox]');
      buttons.forEach((button) => {
        HtmlLightbox(button, {
          maxWidth: 1600,
          html: `<img src="${button.href}" class="lightbox__image" alt="">`,
        });
      });
    });
  }
});
